import axios from 'axios';
import { apiURL } from './Constants';
let API = axios.create({
    // headers: {
    //   authToken : ( (localStorage.getItem("login_details")) ? JSON.parse(localStorage.getItem("login_details")).authToken : '')
    //   }
    }
)

export const GetAPI = async ( url ,callback) => {
    await API.get( apiURL+url)
    .then(function (response) {
        callback(response.data);
    })
    .catch(function (error) {
        callback(error.response.data);
    });
}

export const PostAPI = async ( {url, data} ,callback) => {
    await API.post( apiURL+url, data)
    .then(function (response) {
        if(response && response.data){
            callback(response.data);
        }else{
            callback(false);
        }
    })
    .catch(function (error) {
        if(error && error.response){
            callback(error.response.data);
        }else{
            callback(false);
        }
    });
}
